module.exports = __webpack_public_path__ + "static/img/SM@2x.a57f601a.jpg";